var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting__content-about"},[_c('img',{attrs:{"width":"150","src":require("@/assets/img/login-logo.png"),"alt":"logo"}}),_c('div',{staticClass:"about-version"},[_vm._v("版本号："+_vm._s(_vm.version))])])
}
var staticRenderFns = []

export { render, staticRenderFns }